import React from "react";
import ReactPortalsRoot from "../ReactPortalsRoot/ReactPortalsRoot";
import TextConfirmation from "./TextConfirmation";

export default class ModalDuplicateConfirmation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      textConfirmation: false,
    };

    this.onTextConfirmation = this.onTextConfirmation.bind(this);
  }

  render() {
    if (
      this.props.duplication_warnings &&
      this.props.duplication_warnings.length > 0
    ) {
      return (
        <ReactPortalsRoot
          children={[this.renderModal()]}
          wrapperClassNames="ModalWarningWrapper"
        />
      );
    } else {
      return null;
    }
  }

  renderModal() {
    return (
      <div
        key="ModalDuplicateConfirmation"
        className="ModalWarning modal-content"
      >
        {this.renderModalHeader()}
        {this.renderModalBody()}
        {this.renderModalFooter()}
      </div>
    );
  }

  renderModalHeader() {
    return (
      <div className="modal-header">
        <div className="modal-title">
          <h4>{I18n.t("duplication_warnings")}</h4>
        </div>
        <div className="modal-header-help-icon-close-wrapper">
          <div className="close-icon-wrapper">
            <button
              type="button"
              className="close"
              onClick={() => {
                this.setState({ textConfirmation: false }, this.props.onClose);
              }}
            >
              <span aria-hidden="true">&times;</span>
              <span className="sr-only">{I18n.t("close")}</span>
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderModalBody() {
    const warnings = this.props.duplication_warnings.map((warning) => {
      return (
        <li key={warning.model} style={{ listStyle: "none" }}>
          <strong
            style={{
              textTransform: "capitalize",
              display: "inline-block",
              marginBottom: "5px",
            }}
          >
            {warning.model}
          </strong>
          <ul
            style={{
              lineHeight: "1.3em",
              listStyleType: "disc",
              marginLeft: "15px",
            }}
          >
            {warning.records.map((record) => {
              return (
                <li key={record.id}>
                  {record.name} ({record.code})
                </li>
              );
            })}
          </ul>
        </li>
      );
    });
    return (
      <div className="modal-body">
        <div
          className="alert alert-warning"
          style={{ marginBottom: 0 }}
          role="alert"
        >
          {/* <h4 className="alert-heading" style={{ marginBottom: "15px" }}>
            {I18n.t("duplication_warnings")}
          </h4> */}
          <p>{I18n.t("confirm_duplication_moving_of_records")}</p>
          <ul style={{ padding: 0 }}>{warnings}</ul>
          <TextConfirmation onTextConfirmation={this.onTextConfirmation} />
        </div>
      </div>
    );
  }

  renderModalFooter() {
    return (
      <div className="modal-footer">
        <span className="warning-modal-footer">
          <button
            className="btn btn-secondary"
            onClick={() => {
              this.setState({ textConfirmation: false }, this.props.onClose);
            }}
          >
            {I18n.t("cancel")}
          </button>
          <button
            className="btn btn-primary"
            disabled={!this.state.textConfirmation}
            onClick={this.props.onConfirm}
          >
            {I18n.t("submit")}
          </button>
        </span>
      </div>
    );
  }

  /**
   * Change handlers
   */

  onTextConfirmation(textConfirmation) {
    this.setState({ textConfirmation: textConfirmation });
  }
}
